import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["type", "value", "placeholder", "disabled"]
const _hoisted_2 = ["type", "value", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_group_block = _resolveComponent("form-group-block")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_form_group_block, {
    borderClass: [ _ctx.disabled ? 'disabled' : '', _ctx.borderClass ]
  }, {
    label: _withCtx(() => [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ]),
    description: _withCtx(() => [
      _renderSlot(_ctx.$slots, "description")
    ]),
    default: _withCtx(() => [
      (!_ctx.isEditor)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: _normalizeClass(["form-control", _ctx.inputClass]),
            autofocus: "",
            type: _ctx.type,
            value: _ctx.modelValue,
            placeholder: _ctx.placeholder,
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args))),
            disabled: _ctx.disabled
          }, null, 42, _hoisted_1)), [
            [_directive_maska, _ctx.mask]
          ])
        : _createCommentVNode("", true),
      (_ctx.isEditor)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            class: _normalizeClass(["form-control", _ctx.inputClass]),
            autofocus: "",
            type: _ctx.type,
            value: _ctx.modelValue,
            placeholder: _ctx.placeholder,
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args))),
            disabled: _ctx.disabled
          }, null, 42, _hoisted_2)), [
            [_directive_maska, _ctx.mask]
          ])
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["borderClass"]))
}